module.exports = __webpack_public_path__ + "h5assets/img/coin.5af0e89.png";